module.exports = __webpack_public_path__ + "img/webcam-01.a844603f.svg";